import type { MyOrdine, MyOrdineItem } from '../hooks/useMyOrdini';

/** Stato di un ordine come lo deriva il gestionale (flag NTS,
 *  `clienti/portale_dati_router._derive_order_status`). Unica tabella per
 *  l'Area Clienti e per l'admin: vedono lo stesso stato. */
export const STATO_ORDINE: Record<MyOrdine['status'], { label: string; dot: string; badge: string }> = {
  in_lavorazione: { label: 'In lavorazione', dot: 'bg-sky-500',     badge: 'text-sky-800 bg-sky-50 border-sky-200' },
  confermato:     { label: 'Confermato',     dot: 'bg-indigo-500',  badge: 'text-indigo-800 bg-indigo-50 border-indigo-200' },
  // Partito in parte, ancora aperto su NTS (INT-131).
  evaso_parziale: { label: 'Evasione parziale', dot: 'bg-teal-500', badge: 'text-teal-800 bg-teal-50 border-teal-200' },
  sospeso:        { label: 'Sospeso',        dot: 'bg-amber-500',   badge: 'text-amber-800 bg-amber-50 border-amber-200' },
  evaso:          { label: 'Evaso',          dot: 'bg-emerald-500', badge: 'text-emerald-800 bg-emerald-50 border-emerald-200' },
  annullato:      { label: 'Annullato',      dot: 'bg-gray-400',    badge: 'text-gray-700 bg-gray-100 border-gray-200' },
};

export function statoOrdine(status: string) {
  return STATO_ORDINE[status as MyOrdine['status']] ?? STATO_ORDINE.in_lavorazione;
}

/** Stato di una riga d'ordine (`erp.ordini.stato_riga`, INT-131). */
export type StatoRiga = 'aperta' | 'parziale' | 'evasa' | 'chiusa' | 'annullata';

export const STATO_RIGA: Record<StatoRiga, { label: string; badge: string }> = {
  aperta:    { label: 'Da evadere',     badge: 'text-slate-600 bg-slate-50 border-slate-200' },
  parziale:  { label: 'Evasa in parte', badge: 'text-teal-700 bg-teal-50 border-teal-200' },
  evasa:     { label: 'Evasa',          badge: 'text-emerald-700 bg-emerald-50 border-emerald-200' },
  chiusa:    { label: 'Chiusa',         badge: 'text-amber-700 bg-amber-50 border-amber-200' },
  annullata: { label: 'Annullata',      badge: 'text-gray-600 bg-gray-100 border-gray-200' },
};

/** Lo stato della riga: quello del backend; per una cache senza, dalle
 *  quantità. In un ordine annullato ogni riga è annullata. */
export function statoRiga(item: Pick<MyOrdineItem, 'stato' | 'quantita' | 'quantitaEvasa'>, orderStatus?: string) {
  if (orderStatus === 'annullato') return STATO_RIGA.annullata;
  let s = item.stato as StatoRiga | undefined;
  if (!s || !STATO_RIGA[s]) {
    const evasa = item.quantitaEvasa || 0;
    s = item.quantita <= 0 ? 'annullata' : evasa >= item.quantita ? 'evasa' : evasa > 0 ? 'parziale' : 'aperta';
  }
  return STATO_RIGA[s];
}
